'use strict';

module.exports = global.location || {
  origin: 'http://localhost:80'
, protocol: 'http:'
, host: 'localhost'
, port: 80
, href: 'http://localhost/'
, hash: ''
};



//////////////////
// WEBPACK FOOTER
// ./~/sockjs-client/lib/location.js
// module id = 113
// module chunks = 0